export default __webpack_public_path__ + "static/media/ContentLoading.ad5131f8.svg";